import MobileMenu from "./MobileMenu";
import BunkerLogo from "../../../images/barbell_bunker_white.png";
import InstagramLogo from "../../../images/iglogo.png";
import "./style.css";

function Header(props: any) {
  const isDesktop = props.isDesktop;

  return (
    <div className="Header" id="main">
      {isDesktop ? (
        <header className="desktop">
          <div className="menu">
            <a href="#main" className="logo-icon">
              <img src={BunkerLogo as unknown as string} alt="Your Logo" />
            </a>
            <a href="#about">
              <span>Rólunk</span>
            </a>
            <a href="#trainers">
              <span>Edzőink</span>
            </a>
            <a href="#pw">
              <span>Erőemelés</span>
            </a>
            <a href="#contact">
              <span>Kapcsolat</span>
            </a>
            <div className="social-icons">
              <a
                href="https://www.instagram.com/barbell_bunker/"
                target="_blank"
                rel="noreferrer"
              >
                <img alt="Instagram" src={InstagramLogo as unknown as string} />
              </a>
            </div>
          </div>
        </header>
      ) : null}
      {!isDesktop ? <MobileMenu></MobileMenu> : null}
    </div>
  );
}

export default Header;
